// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- new color definitions from design system */
/* IMPORTANT: hen changing token values update and convert their -rgb values as well! Vanilla css cannot use rgb(#hex) to convert hex to rgb */
:root {
    /* Aliases used in the component tokens, or directly in screens.
    In future we may consider to keep here all that is needed in order to alter theming.
    This is subject to our needs and the design requirements. */
    --ds-bg-global: var(--ds-color-grey-100);
    --ds-color-error: var(--ds-color-negative);
    --ds-color-focus-outline: var(--ds-color-neon-0);
    /* Overlays */
    --ds-overlay-bg-color: rgb(
        var(--ds-color-grey-90-rgb) / var(--ds-alpha-80)
    );
    --ds-overlay-soft-bg-color: rgb(
        var(--ds-color-grey-indigo-100-rgb) / var(--ds-alpha-20)
    );
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
